/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FixedPriceProjectContractLineResource
 */
export interface FixedPriceProjectContractLineResource {
    /**
     * 
     * @type {string}
     * @memberof FixedPriceProjectContractLineResource
     */
    lineId: string;
    /**
     * 
     * @type {string}
     * @memberof FixedPriceProjectContractLineResource
     */
    description: string;
    /**
     * 
     * @type {number}
     * @memberof FixedPriceProjectContractLineResource
     */
    quantity: number;
    /**
     * 
     * @type {number}
     * @memberof FixedPriceProjectContractLineResource
     */
    unitPriceExcludingTaxes: number;
    /**
     * 
     * @type {number}
     * @memberof FixedPriceProjectContractLineResource
     */
    totalPriceExcludingTaxes?: number;
}

/**
 * Check if a given object implements the FixedPriceProjectContractLineResource interface.
 */
export function instanceOfFixedPriceProjectContractLineResource(value: object): value is FixedPriceProjectContractLineResource {
    if (!('lineId' in value) || value['lineId'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    if (!('unitPriceExcludingTaxes' in value) || value['unitPriceExcludingTaxes'] === undefined) return false;
    return true;
}

export function FixedPriceProjectContractLineResourceFromJSON(json: any): FixedPriceProjectContractLineResource {
    return FixedPriceProjectContractLineResourceFromJSONTyped(json, false);
}

export function FixedPriceProjectContractLineResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): FixedPriceProjectContractLineResource {
    if (json == null) {
        return json;
    }
    return {
        
        'lineId': json['lineId'],
        'description': json['description'],
        'quantity': json['quantity'],
        'unitPriceExcludingTaxes': json['unitPriceExcludingTaxes'],
        'totalPriceExcludingTaxes': json['totalPriceExcludingTaxes'] == null ? undefined : json['totalPriceExcludingTaxes'],
    };
}

export function FixedPriceProjectContractLineResourceToJSON(value?: FixedPriceProjectContractLineResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'lineId': value['lineId'],
        'description': value['description'],
        'quantity': value['quantity'],
        'unitPriceExcludingTaxes': value['unitPriceExcludingTaxes'],
        'totalPriceExcludingTaxes': value['totalPriceExcludingTaxes'],
    };
}

